import React, {useState} from 'react';
import {Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import YoutubePlayer from 'react-youtube-player';

const VideoModal = (props) => {

	const [backdrop, setBackdrop] = useState(false);

    return (
        <div>
			<Modal isOpen={props.isOpen} toggle={props.close} size={"lg"} backdrop={backdrop}>
				<ModalHeader toggle={props.close}>{props.video.title}</ModalHeader>
				<ModalBody style={{ height: "350px"}}>
					<YoutubePlayer
						videoId={props.video.id}
						playbackState='unstarted'
					/>
				</ModalBody>
				<ModalFooter/>
			</Modal>
        </div>
    )
};

export default VideoModal;